module.exports = __webpack_public_path__ + "img/corporateApply1.c9cb53c3.png";